import { createPortal } from 'react-dom';
const Title = ({
  title,
  episodeNumber
}: {
  title: string;
  episodeNumber?: number | null;
}) => {
  return <div className={'program-info-title'} data-sentry-component="Title" data-sentry-source-file="ProgramInfoOverlay.tsx">
      <span>
        {episodeNumber && `Avsnitt ${episodeNumber} · `}
        {title}
      </span>
    </div>;
};
const Metadata = ({
  seriesLabel,
  seriesTitle,
  mainGenre
}: {
  seriesLabel?: string | null;
  seriesTitle: string | null;
  mainGenre?: string;
}) => {
  const episodeMetadata = seriesLabel ? `${seriesTitle} · ${seriesLabel}` : seriesTitle;
  return <div className={'program-info-metadata'} data-sentry-component="Metadata" data-sentry-source-file="ProgramInfoOverlay.tsx">
      <span>{seriesTitle ? episodeMetadata : mainGenre}</span>
    </div>;
};
const ProgramInfoOverlay = ({
  title,
  episodeNumber,
  seriesTitle,
  mainGenre,
  seriesLabel,
  player,
  isFullscreen,
  fullscreenContainer
}: {
  title: string;
  episodeNumber: number | null;
  seriesTitle: string | null;
  mainGenre: string;
  seriesLabel?: string | null;
  player: jwplayer.JWPlayer | null;
  isFullscreen: boolean;
  fullscreenContainer: HTMLDivElement | null;
}) => {
  if (!player) return null;
  const infoOverlay = <div className={'program-info-container'}>
      <Title title={title} episodeNumber={episodeNumber} />
      <Metadata seriesTitle={seriesTitle} mainGenre={mainGenre} seriesLabel={seriesLabel} />
    </div>;
  return isFullscreen && fullscreenContainer ? createPortal(infoOverlay, fullscreenContainer) : null;
};
export default ProgramInfoOverlay;